module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <compliance-overview></compliance-overview>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <detailed-compliance-breakdown></detailed-compliance-breakdown>\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/users/compliance/template.html
// module id = 1088
// module chunks = 0